import base from './base';

const paymentAPI = dispatch => {
  return {
    async upgrade(data) {
      return base.privateApi(dispatch, {
        path: `/user/purchase`,
        method: 'post',
        data,
      });
    },
  };
};

export default paymentAPI;
